import React from 'react';
import { ToastManager, TOAST_TYPES } from '../fasades/toastmanager';
import { IoMdCopy } from 'react-icons/io';
import { Example } from './apireftypes';
import { ExampleLanguageSelector } from './examplelanguageselector';
import './apiexamplecode.css';

type Language = 'curl' | 'javascript' | 'python';

interface Props {
    title     : string;
    examples  : Example[];
    onExampleChange?: (index: number) => void;
}

interface State {
    selectedLanguage: Language;
    selectedExampleIndex: number;
}

export class ApiExampleCode extends React.Component<Props, State> 
{
    constructor(props: Props) {
        super(props);
        this.state = {
            selectedLanguage: 'curl',
            selectedExampleIndex: 0
        };
    }

    getCurrentExample(): Example {
        const validIndex = Math.min(this.state.selectedExampleIndex, this.props.examples.length - 1);
        return this.props.examples[validIndex];
    }


    handleLanguageChange(language: Language) {
        this.setState({ selectedLanguage: language });
    }

    handleExampleChange(index: number) {
        this.setState({ selectedExampleIndex: index });
        if (this.props.onExampleChange) {
            this.props.onExampleChange(index);
        }
    }

    getCurrentCode(): string {
        const example = this.getCurrentExample();
        
        switch (this.state.selectedLanguage) {
            case 'curl':
                return example.codeCurl;
            case 'javascript':
                return example.codeJavaScript;
            case 'python':
                return example.codePython;
        }
    }

    getLanguageLabel(): string {
        switch (this.state.selectedLanguage) {
            case 'curl':
                return 'cURL';
            case 'javascript':
                return 'JavaScript (fetch)';
            case 'python':
                return 'Python (requests)';
        }
    }

    handleCopy() {
        const code = this.getCurrentCode();
        navigator.clipboard.writeText(code)
            .then(() => ToastManager.addToast('Code copied to clipboard!', TOAST_TYPES.SUCCESS, 3000))
            .catch(() => ToastManager.addToast('Failed to copy code', TOAST_TYPES.ERROR, 3000));
    }

    render() {
        const currentCode = this.getCurrentCode();
        const currentExample = this.getCurrentExample();
        const displayTitle = currentExample.title !== undefined
            ? `${this.props.title} (${currentExample.title})`
            : this.props.title;

        return (
            <div className="api-example-code">
                <div className="example-header-bar">
                    <h3 className="example-title">{displayTitle}</h3>
                    <div className="example-controls">
                        <ExampleLanguageSelector
                            examples={this.props.examples}
                            selectedExampleIndex={this.state.selectedExampleIndex}
                            selectedLanguage={this.state.selectedLanguage}
                            onExampleChange={(index) => this.handleExampleChange(index)}
                            onLanguageChange={(language) => this.handleLanguageChange(language)}
                        />
                        <button
                            type="button"
                            className="copy-button"
                            onClick={() => this.handleCopy()}
                            title="Copy to clipboard"
                        >
                            {React.createElement(IoMdCopy as React.ComponentType)}
                        </button>
                    </div>
                </div>

                <div className="example-section">
                    <pre className="code-block">
                        <code>{currentCode}</code>
                    </pre>
                </div>
            </div>
        );
    }
}

